import * as React from "react";
import { toggle } from "../../../util/common";
import { WalletItemCombination } from "../../../store/common";
import { useState } from "react";
import { DialogComponent } from "../../common/DialogComponent";
import ConfirmDeleteWalletDialog from "../../Dialogs/lostWallet/ConfirmDeleteWalletDialog";
import CombinationDialog from "../../Dialogs/lostWallet/CombinationDialog";
import { useTranslation } from "react-i18next";

const Combination: React.FunctionComponent<{ requestDataCallback(): void; walletItemCombinations: WalletItemCombination[] }> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const [deleteWalletDialogIsVisible, setDeleteWalletDialogIsVisible] = useState(false);
    const [combinationDialogIsVisible, setCombinationDialogIsVisible] = useState(false);
    const [selectedItem, setSelectedItem] = useState({});

    const showDeleteWalletDialog = (selectedItem: WalletItemCombination): any => {
        setSelectedItem(selectedItem);
        setDeleteWalletDialogIsVisible(true);
    };

    const closeDeleteWalletDialog = (): any => {
        setDeleteWalletDialogIsVisible(false);
    };

    const showCombinationDialog = (selectedItem: WalletItemCombination): any => {
        setSelectedItem(selectedItem);
        setCombinationDialogIsVisible(true);
    };

    const closeCombinationDialog = (): any => {
        setCombinationDialogIsVisible(false);
    };

    return (
        <React.Fragment>
            {props.walletItemCombinations &&
                props.walletItemCombinations.map((combination: WalletItemCombination, index) => (
                    <div className="data-row" key={"combination-" + index}>
                        <div className="link-item">
                            <button
                                type="button"
                                aria-expanded="false"
                                className="link-button"
                                id={"combination-" + index}
                                onClick={() => toggle(`combination-${index}-details`, `combination-${index}`)}
                            >
                                <span className="row link-item">
                                    <span className="col-xs col-no-gutter link-text">
                                        <span className="link-title">
                                            <span className="sr-only btn-toggle-status">Show</span> {combination.itemName}
                                        </span>
                                        <span className="link-helper">
                                            <span className="sr-only">Item Type: </span>
                                            {tLang("identityVault.secureStorage.lostWallterWidget.combination.title2")}
                                        </span>
                                    </span>
                                </span>
                            </button>

                            <div className="wallet-details" id={"combination-" + index + "-details"} style={{ display: "none" }}>
                                <div
                                    role="grid"
                                    className="data-grid row-height-xs"
                                    aria-labelledby={"combination-" + index + "-title"}
                                    id={"combination-" + index + "-title"}
                                >
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"combination-" + index + "-name-of-item"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.combination.label.nameOfItem")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"combination-" + index + "-name-of-item"}>
                                                {combination.itemName}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"combination-" + index + "-combination"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.combination.label.combination")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"combination-" + index + "-combination"}>
                                                {combination.itemCombination}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"combination-" + index + "-location-of-item"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.combination.label.location")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"combination-" + index + "-location-of-item"}>
                                                {combination.itemLocation}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"combination-" + index + "-location-of-key"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.combination.label.key")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"combination-" + index + "-location-of-key"}>
                                                {combination.keyLocation}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"combination-" + index + "-notes"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.combination.label.notes")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"combination-" + index + "-notes"}>
                                                {combination.notes}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row between-xs margin-top-l">
                                    <div className="col-xs flex-grow-null col-no-gutter"></div>
                                    <div className="col-xs flex-grow-null col-no-gutter">
                                        <ul className="list-reset list-inline">
                                            <li>
                                                <button
                                                    type="button"
                                                    className="btn-default btn-red-outline btn-no-border"
                                                    onClick={() => showDeleteWalletDialog(combination)}
                                                >
                                                    <span className="btn-icon">
                                                        <em className="las la-trash-alt"></em>
                                                    </span>
                                                    <span className="btn-text">
                                                        {tLang("identityVault.secureStorage.lostWallterWidget.combination.deleteButtonText")}
                                                    </span>
                                                </button>
                                            </li>
                                            <li className="margin-left-xs">
                                                <button
                                                    type="button"
                                                    className="btn-default btn-primary-outline"
                                                    id="edit-credit-card-1"
                                                    onClick={() => showCombinationDialog(combination)}
                                                >
                                                    <span className="btn-icon">
                                                        <em className="las la-edit-alt"></em>
                                                    </span>
                                                    <span className="btn-text">
                                                        {tLang("identityVault.secureStorage.lostWallterWidget.combination.editDetailsButtonText")}
                                                    </span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

            {/* Delete modal*/}
            {deleteWalletDialogIsVisible && (
                <DialogComponent dialogId="dialog-delete-combination-wallet" title="Delete Wallet" closeDialog={closeDeleteWalletDialog}>
                    <ConfirmDeleteWalletDialog
                        requestDataCallback={props.requestDataCallback}
                        closeDialog={closeDeleteWalletDialog}
                        walletItem={selectedItem}
                        itemType="combination"
                    />
                </DialogComponent>
            )}

            {/* Edit modal*/}
            {combinationDialogIsVisible && (
                <DialogComponent dialogId="dialog-edit-bank-account-wallet" title="Edit Credit Card Wallet" closeDialog={closeCombinationDialog}>
                    <CombinationDialog
                        requestDataCallback={props.requestDataCallback}
                        closeDialog={closeCombinationDialog}
                        walletItem={selectedItem}
                        isNew={false}
                    />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default Combination;
